import { render, staticRenderFns } from "./FlatAgeTable.vue?vue&type=template&id=1b837698"
import script from "./FlatAgeTable.vue?vue&type=script&lang=js"
export * from "./FlatAgeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports